import httpRequest from 'httpRequest'
import { NotificationChannelContract } from 'models'

const NOTIFICATION_CHANEL_PREFIX = '/location/notification-channels'

const notificationChannelService = {
    getNotificationChannels: () =>
        httpRequest.get<NotificationChannelContract[]>(
            NOTIFICATION_CHANEL_PREFIX,
        ),
}

export default notificationChannelService
